import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoveControl = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 20,
	viewBox: "0 0 14 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5216_65637)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M2.65605 4.74168C3.85382 4.74168 4.8248 3.7707 4.8248 2.57293C4.8248 1.37516 3.85382 0.404175 2.65605 0.404175C1.45829 0.404175 0.487305 1.37516 0.487305 2.57293C0.487305 3.7707 1.45829 4.74168 2.65605 4.74168Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.61651 2.57289C4.61026 3.38331 4.09985 4.13957 3.32901 4.41457C2.54776 4.69373 1.67485 4.45207 1.14151 3.81665C0.612346 3.1854 0.556096 2.24998 0.98318 1.55206C1.40193 0.862472 2.23735 0.487471 3.0311 0.647888C3.94568 0.833306 4.61026 1.64164 4.61651 2.57289C4.6186 2.84165 5.03526 2.84165 5.03318 2.57289C5.02693 1.57706 4.39985 0.685388 3.46651 0.337471C2.5436 -0.00419712 1.45401 0.291637 0.831096 1.05414C0.197763 1.82914 0.0998462 2.94165 0.624846 3.80415C1.14568 4.6604 2.16443 5.09582 3.1436 4.89999C4.23735 4.67915 5.02693 3.67915 5.03526 2.57289C5.03526 2.30414 4.6186 2.30414 4.61651 2.57289Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.65605 12.1687C3.85382 12.1687 4.8248 11.1977 4.8248 9.99995C4.8248 8.80217 3.85382 7.83118 2.65605 7.83118C1.45829 7.83118 0.487305 8.80217 0.487305 9.99995C0.487305 11.1977 1.45829 12.1687 2.65605 12.1687Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.61651 10C4.61026 10.8104 4.09985 11.5667 3.32901 11.8417C2.54776 12.1208 1.67485 11.8792 1.14151 11.2438C0.612346 10.6125 0.556096 9.67709 0.98318 8.97918C1.40193 8.28959 2.23735 7.91459 3.0311 8.07501C3.94568 8.26043 4.61026 9.06876 4.61651 10C4.6186 10.2688 5.03526 10.2688 5.03318 10C5.02693 9.00418 4.39985 8.11251 3.46651 7.76459C2.5436 7.42293 1.45401 7.71876 0.831096 8.48126C0.197763 9.25626 0.0998462 10.3688 0.624846 11.2313C1.14568 12.0875 2.16443 12.5229 3.1436 12.3271C4.23735 12.1063 5.02693 11.1063 5.03526 10C5.03526 9.73126 4.6186 9.73126 4.61651 10Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.65605 19.5958C3.85382 19.5958 4.8248 18.6248 4.8248 17.4271C4.8248 16.2293 3.85382 15.2583 2.65605 15.2583C1.45829 15.2583 0.487305 16.2293 0.487305 17.4271C0.487305 18.6248 1.45829 19.5958 2.65605 19.5958Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.61651 17.4271C4.61026 18.2376 4.09985 18.9938 3.32901 19.2688C2.54776 19.548 1.67485 19.3063 1.14151 18.6709C0.612346 18.0396 0.556096 17.1042 0.98318 16.4063C1.40193 15.7167 2.23735 15.3417 3.0311 15.5021C3.94568 15.6876 4.61026 16.4959 4.61651 17.4271C4.6186 17.6959 5.03526 17.6959 5.03318 17.4271C5.02693 16.4313 4.39985 15.5396 3.46651 15.1917C2.5436 14.8501 1.45401 15.1459 0.831096 15.9084C0.197763 16.6834 0.0998462 17.7959 0.624846 18.6584C1.14568 19.5147 2.16443 19.9501 3.1436 19.7542C4.23735 19.5334 5.02693 18.5334 5.03526 17.4271C5.03526 17.1584 4.6186 17.1584 4.61651 17.4271Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6775 4.74168C11.8753 4.74168 12.8463 3.7707 12.8463 2.57293C12.8463 1.37516 11.8753 0.404175 10.6775 0.404175C9.47977 0.404175 8.50879 1.37516 8.50879 2.57293C8.50879 3.7707 9.47977 4.74168 10.6775 4.74168Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.637 2.57289C12.6308 3.38331 12.1203 4.13957 11.3495 4.41457C10.5683 4.69373 9.69535 4.45207 9.16202 3.81665C8.63285 3.1854 8.5766 2.24998 9.00368 1.55206C9.42243 0.862472 10.2578 0.487471 11.0516 0.647888C11.9662 0.833306 12.6308 1.64164 12.637 2.57289C12.6391 2.84165 13.0557 2.84165 13.0537 2.57289C13.0474 1.57706 12.4203 0.685388 11.487 0.337471C10.5641 -0.00419712 9.47452 0.291637 8.8516 1.05414C8.21827 1.82914 8.12035 2.94165 8.64535 3.80415C9.16618 4.6604 10.1849 5.09582 11.1641 4.89999C12.2578 4.67915 13.0474 3.67915 13.0558 2.57289C13.0558 2.30414 12.6391 2.30414 12.637 2.57289Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6775 12.1687C11.8753 12.1687 12.8463 11.1977 12.8463 9.99995C12.8463 8.80217 11.8753 7.83118 10.6775 7.83118C9.47977 7.83118 8.50879 8.80217 8.50879 9.99995C8.50879 11.1977 9.47977 12.1687 10.6775 12.1687Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.637 10C12.6308 10.8104 12.1203 11.5667 11.3495 11.8417C10.5683 12.1208 9.69535 11.8792 9.16202 11.2438C8.63285 10.6125 8.5766 9.67709 9.00368 8.97918C9.42243 8.28959 10.2578 7.91459 11.0516 8.07501C11.9662 8.26043 12.6308 9.06876 12.637 10C12.6391 10.2688 13.0557 10.2688 13.0537 10C13.0474 9.00418 12.4203 8.11251 11.487 7.76459C10.5641 7.42293 9.47452 7.71876 8.8516 8.48126C8.21827 9.25626 8.12035 10.3688 8.64535 11.2313C9.16618 12.0875 10.1849 12.5229 11.1641 12.3271C12.2578 12.1063 13.0474 11.1063 13.0558 10C13.0558 9.73126 12.6391 9.73126 12.637 10Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6775 19.5958C11.8753 19.5958 12.8463 18.6248 12.8463 17.4271C12.8463 16.2293 11.8753 15.2583 10.6775 15.2583C9.47977 15.2583 8.50879 16.2293 8.50879 17.4271C8.50879 18.6248 9.47977 19.5958 10.6775 19.5958Z",
					fill: "#C6CCDA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.637 17.4271C12.6308 18.2376 12.1203 18.9938 11.3495 19.2688C10.5683 19.548 9.69535 19.3063 9.16202 18.6709C8.63285 18.0396 8.5766 17.1042 9.00368 16.4063C9.42243 15.7167 10.2578 15.3417 11.0516 15.5021C11.9662 15.6876 12.6308 16.4959 12.637 17.4271C12.6391 17.6959 13.0557 17.6959 13.0537 17.4271C13.0474 16.4313 12.4203 15.5396 11.487 15.1917C10.5641 14.8501 9.47452 15.1459 8.8516 15.9084C8.21827 16.6834 8.12035 17.7959 8.64535 18.6584C9.16618 19.5147 10.1849 19.9501 11.1641 19.7542C12.2578 19.5334 13.0474 18.5334 13.0558 17.4271C13.0558 17.1584 12.6391 17.1584 12.637 17.4271Z",
					fill: "#C6CCDA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5216_65637",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 13.3333,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMoveControl);
export default ForwardRef;
